import React from 'react';
import { observer } from 'mobx-react';
import { action, makeObservable, observable } from 'mobx';

type ContextSubMenuProps = {
  className?: string;
  visible: boolean;
  children?: React.ReactNode;
};

@observer
export default class ContextSubMenu extends React.Component<ContextSubMenuProps> {
  @observable.ref private _subMenu: React.RefObject<HTMLDivElement | null> = React.createRef();
  isPlacedTop = false;
  isPlacedLeft = false;
  private _resizeObserver: ResizeObserver | null = null;
  @observable private _width: number = 0;
  @observable private _height: number = 0;

  constructor(props: ContextSubMenuProps) {
    super(props);
    makeObservable(this);
  }

  componentDidUpdate(){
    if (this._subMenu.current){
      this._subMenu.current.className = this._getClassName();
    }
  }

  componentDidMount(){
    if (this._subMenu.current){
      this._subMenu.current.className = this._getClassName();
      
      this._resizeObserver = new ResizeObserver(entries => {
        for (let entry of entries) {
          const { width, height } = entry.contentRect;
          this._onResize(width, height);
        }
      });
      this._resizeObserver.observe(this._subMenu.current);
    }
  }
  

  componentWillUnmount() {
    if (this._resizeObserver && this._subMenu.current) {
      this._resizeObserver.unobserve(this._subMenu.current);
      this._resizeObserver.disconnect();
    }
  }

  render(){
    const className = this._getClassName();
    return (
      <div ref={this._subMenu} className={className}>
        {this.props.children}
      </div>
    );
  }

  @action.bound
  private _onResize(width?: number, height?: number){
    if (width){
      this._width = width;
    }
    if (height){
      this._height = height;
    }
  }

  private _getClassName() {
    let className = 'contextMenu children-wrap' + `${this.props.className ? ` ${this.props.className}` : ''}`;
    if (!this._subMenu.current || this.props.className) {
      return className;
    }

    const subMenuRect = this._subMenu.current.getBoundingClientRect();
    const clickY = subMenuRect.top;
    const clickX = subMenuRect.left;
    const screenH = window.innerHeight;
    const screenW = window.innerWidth;
    const rootH = this._height || subMenuRect.height;
    const rootW = this._width || subMenuRect.width;
    if ((screenH - clickY) <= (rootH + 5)){
      this.isPlacedTop = true;
    }
    if ((screenW - clickX) <= (rootW + 5)){
      this.isPlacedLeft = true;
    }

    if(this.isPlacedTop){
      className += ' children-wrap-top';
    }
    if(this.isPlacedLeft){
      className += ' reverse';
    }

    return className;
  }
}
